import API from '@/api';
// const User = API.get('User');
const Schedule = API.get('Schedule');

export default ({
  namespaced: true,
  state: {
    schedules: [],
    userSchedule: []
  },
  getters: {
    schedules: state => state.schedules,
    userSchedule: state => state.userSchedule
  },
  mutations: {
    setSchedules(state, schedules) {
      console.log('commit', schedules)
      state.schedules = schedules
    },
    setUserSchedule(state, schedule) {
      state.userSchedule = schedule
    },
  },
  actions: {
    async deleteSchedule(state, id) {
      var response = await Schedule.delete(id);
      console.log('[schedule/deleteSchedule]', response.data)
    },
    // async fetchSchedule(state, id=null) {
    //   var response = await Schedule.get(id);
    //   console.log(response, response.data['2020-09-03'])
    //   state.commit('setSchedules', response.data['2020-09-03'])
    // },
    // fetch users with schedule
    // async fetchUserSchedule({commit}) {
    //   var testResponse = await User.getDoctors();
    //   var response = await User.getDoctors(testResponse.data.total);
    //   var doctors = response.data.data.filter(doctor => doctor.schedules.length >= 1).map(doctor => {
    //     console.log(doctor.username, doctor)
    //     return ({
    //       doctor: doctor,
    //       schedules: doctor.schedules
    //     })
    //   })
    //   console.log('[doctors-with-schedule]', doctors)
    //   commit('setUserSchedule', doctors)
    // }
  }
})